import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-set-forms',
  templateUrl: './set-forms.component.html',
  styleUrls: ['./set-forms.component.sass']
})
export class SetFormsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
